const barcodeTranslation = {
  menu: 'Barcode',
  barcodeMenu: 'Barcode',
  specialBarcodeMenu: 'Special Barcode Management',
  specialBarcodeTab: 'Special barcodes (DEV, TEST, REFUND)',
  pinkExceptionTab: 'Pink barcode blocking exceptions',
  pinkExceptionHelp: 'How pink barcode blocking exceptions take effect',
  pinkExceptionSaveHelp:
    'Register a barcode to grant an exception to pink barcode blocking. Registration and revocation automatically update the list that devices download.',
  pinkExceptionSyncHelp:
    'Devices running MommyBox v2.11.313 or later sync with the server at startup and nightly while powered on and connected to the internet.',
  pinkExceptionOfflineHelp:
    'Offline devices and devices that fail to sync keep using their last downloaded list. Changes take effect after a successful sync at the next startup or nightly check.',
  pinkExceptionRevokeHelp:
    'Revoking an exception makes the barcode subject to pink barcode blocking again after the next successful sync.',
  pinkBaseListHelp:
    'Exceptions apply only to barcodes issued as pink barcodes. Refund and validity-period restrictions still apply.',
  pinkCreatedBy: 'Registered by',
  pinkSave: 'Grant exception',
  pinkRemove: 'Revoke exception',
  pinkRemoveConfirm: 'Revoke this pink barcode exception?',
  pinkSaveComplete:
    'Exception registered and added to the device list. Devices apply it on their next sync.',
  pinkRemoveComplete:
    'Exception revoked and device list updated. Devices apply the change on their next sync.',
  pinkSavedPublishFailed:
    'Changes were saved, but the device list could not be updated. Select Retry list update.',
  pinkSavedWithoutSync:
    'Changes were saved. Device sync is disabled in this environment, so devices will not receive these changes.',
  pinkPublishComplete: 'Device list updated. Devices apply the changes on their next sync.',
  pinkPublishFailed: 'Could not update the device list. Please try again.',
  pinkSyncPending: 'The device list needs to be updated.',
  pinkPublishNotConfigured:
    'Device sync is disabled in this environment. Registration and revocation are saved only in MDA and will not reach devices.',
  pinkPublished: 'Device list updated',
  pinkPublishedAt: 'Last list update',
  pinkRepublish: 'Retry list update',
  pinkBarcodeRequired: 'Enter an 11-digit numeric barcode.',
  pinkReasonRequired: 'Enter the approval reason.',
  pinkSearch: 'Search barcode or reason',
  pinkLoadFailed: 'Could not load pink barcode blocking exceptions.',
  pinkActionFailed: 'Could not complete the request. Please try again.',
  pinkNoPermission: 'You do not have permission to view these exceptions.',
  firstRecordingBarcodeMenu: 'First Recording Barcode Search',
  firstRecordingBarcodePeriod: 'Period',
  firstRecordingBarcodeAvailableHospitals: 'Available accounts',
  firstRecordingBarcodeSelectedHospitals: 'Selected accounts',
  firstRecordingBarcodeHospitalUnit: 'items',
  firstRecordingBarcodeSelectHospitals: 'Select Accounts',
  firstRecordingBarcodeSelectedHospitalCount: '{{count}} selected',
  firstRecordingBarcodeEmptyHospitalSelection: 'No accounts selected.',
  firstRecordingBarcodeHospitalSearchPlaceholder: 'Search by account name or seq',
  firstRecordingBarcodeClearHospitalSelection: 'Clear all',
  firstRecordingBarcodeApplyHospitalSelection: 'Apply selection',
  firstRecordingBarcodeMoreSelectedHospitals: '+{{count}} more',
  firstRecordingBarcodeHospitalCategory: 'Category',
  firstRecordingBarcodeAllHospitals: 'All',
  firstRecordingBarcodePinkBarcodeHospitals: 'Pink Barcode',
  firstRecordingBarcodePaidHospitals: 'Paid',
  firstRecordingBarcodeQrPaymentHospitals: 'QR Payment',
  firstRecordingBarcodeSearch: 'Search',
  firstRecordingBarcodeSearchBarcode: 'Search Barcode',
  firstRecordingBarcodeSearchBarcodePlaceholder: 'Search only a specific barcode',
  firstRecordingBarcodeSearchComplete: 'Search completed. {{count}} rows',
  firstRecordingBarcodeSearchResultCount: '{{count}} rows found',
  firstRecordingBarcodeFilteredResultCount: '{{count}} filtered',
  firstRecordingBarcodeUserDataRowCount: '{{count}} with user data',
  firstRecordingBarcodeFilteredUserDataRowCount: '{{count}} filtered with user data',
  firstRecordingBarcodeUserDataCsvLabel: 'Rows with user data',
  firstRecordingBarcodeCsvCountValue: '{{count}} rows',
  firstRecordingBarcodeResultBarcodeSearchPlaceholder: 'Search barcode in results',
  firstRecordingBarcodeSelectedRowCount: '{{count}} selected',
  firstRecordingBarcodeSendAll: 'Send All',
  firstRecordingBarcodeSendSelected: 'Send Selected',
  firstRecordingBarcodeSendOne: 'Send',
  firstRecordingBarcodeMessageAction: 'Message',
  firstRecordingBarcodeSendNoTarget: 'No rows to send.',
  firstRecordingBarcodeSendNoSelected: 'Please select rows to send.',
  firstRecordingBarcodeSendConfirmTitle: 'Send Message',
  firstRecordingBarcodeSendConfirmContent: 'Send messages to {{count}} rows?',
  firstRecordingBarcodeSendConfirmOk: 'Send',
  firstRecordingBarcodeSmsMessageLabel: 'Message',
  firstRecordingBarcodeSmsMessagePlaceholder: 'Enter the message to send.',
  firstRecordingBarcodeSmsMessageRequired: 'Please enter a message.',
  firstRecordingBarcodeDefaultSmsMessage: 'Hello, this is MommyTalk.',
  firstRecordingBarcodeSendResult:
    'Message request completed: {{sentCount}} sent, {{skippedCount}} skipped, {{failedCount}} failed',
  firstRecordingBarcodeSendError: 'An error occurred while requesting messages.',
  firstRecordingBarcodeHospitalRequired: 'Please select at least one account.',
  firstRecordingBarcodePeriodRequired: 'Please select a period.',
  firstRecordingBarcodeValidationError: 'Please check the input values.',
  firstRecordingBarcodeExportEmpty: 'No results found.',
  firstRecordingBarcodeExportComplete: 'CSV download completed.',
  firstRecordingBarcodeExportError: 'An error occurred while searching first recording barcodes.',
  downloadCsv: 'Download CSV',
  streamingRestoreMenu: 'Stopped Streaming Video Restore',
  streamingRestoreExploreTitle: 'Restore Target Search',
  streamingRestoreHistoryTitle: 'Restore History',
  streamingRestoreHistoryAll: 'Shows the latest restore history across all barcodes.',
  streamingRestoreHistoryFiltered: 'Shows restore history filtered by barcode {{barcode}}.',
  seq: 'Seq',
  barcode: 'Barcode',
  recordedAt: 'Recorded At',
  hospitalSeq: 'Hospital Seq',
  hospitalName: 'Hospital Name',
  userName: 'User Name',
  userPhoneNumber: 'User Phone Number',
  fileId: 'File ID',
  type: 'Type',
  reason: 'Reason',
  createdBy: 'Registered by',
  createdAt: 'Created At',
  updatedAt: 'Updated At',
  edit: 'Edit',
  delete: 'Delete',
  deleteConfirm: 'Are you sure you want to delete this item?',
  yes: 'Yes',
  no: 'No',
  editBarcodeDetail: 'Edit Barcode',
  description: 'Description',
  activeFlag: 'Active',
  blindRecording: 'Blind Recording',
  blindRecordingDescription: 'Blinds recordings uploaded with this barcode.',
  addSpecialBarcode: 'Add Special Barcode',
  editSpecialBarcode: 'Edit Special Barcode',
  deleteSpecialBarcode: 'Delete Special Barcode',
  specialBarcodeDescription: 'Special Barcode Management',
  specialBarcodeTableDescription:
    'Register and manage special barcodes. Recordings starting with a registered special barcode may be automatically blinded under certain conditions (e.g., no mother information).',
  searchBarcode: 'Search Barcode',
  searchReason: 'Search Reason',
  unblindRecordingsOnDelete: 'Unblind associated recordings upon deletion.',
  expireClassVoucher: 'Expire Class Voucher',
  expireClassVoucherDescription: 'Expires class vouchers registered with this barcode.',
  typeDev: 'DEV',
  typeTest: 'TEST',
  typeRefund: 'REFUND',
  typeFree: 'FREE',
  showFreeBarcodes: 'Include FREE Barcodes',
  bulkBarcodeInput: 'Barcode List',
  bulkBarcodeInputPlaceholder:
    'Paste one line per barcode. Even if copied from Google Sheets with multiple columns, only one 11-digit barcode per line is recognized.',
  barcodeInputSummary:
    '{{total}} lines / {{valid}} valid / {{duplicate}} duplicates / {{invalid}} needs review',
  barcodeInputIssues: 'Needs Review',
  barcodeInputServerFailures: 'Server Registration Failures',
  barcodeInputMissingBarcode: 'No 11-digit barcode was found.',
  barcodeInputMultipleBarcodes: 'More than one barcode was found on the same line.',
  barcodeInputDuplicate: 'This barcode is duplicated in the input.',
  noValidBarcodesToCreate: 'There are no valid barcodes to register.',
  batchAddComplete: 'Registered {{success}} of {{requested}} barcodes.',
  batchAddPartialComplete:
    'Registered {{success}} of {{requested}} barcodes and {{failure}} still need review.',
  freeBarcodeReadOnly:
    'FREE barcodes are auto-generated and cannot be edited manually. Deletion is still allowed.',
  addComplete: 'Add Complete',
  updateComplete: 'Update Complete',
  deleteComplete: 'Delete Complete',
  streamingRestoreSearchPlaceholder: 'Search an 11-digit barcode',
  streamingRestoreSearchHelp:
    'The first result shows only hospital-level inactive counts. Open a hospital to inspect individual recordings.',
  streamingRestoreHospital: 'Hospital',
  streamingRestoreDisabledCount: 'Inactive Videos',
  streamingRestoreRestorableCount: 'Restorable',
  streamingRestoreUnrestorableCount: 'Not Restorable',
  streamingRestoreRequestedCount: 'Requested',
  streamingRestoreRestoredCount: 'Restored',
  streamingRestoreFailedCount: 'Failed',
  streamingRestoreAction: 'Details/Restore',
  streamingRestoreOpenDetail: 'Open',
  streamingRestoreDrawerTitle: '{{hospitalName}} restore targets',
  streamingRestoreSelectedCount: '{{count}} selected',
  streamingRestoreStatus: 'Restorable',
  streamingRestoreStatusRestorable: 'Restorable',
  streamingRestoreStatusUnrestorable: 'Not Restorable',
  streamingRestoreCurrentKey: 'Current s3FileKey',
  streamingRestoreExpectedKey: 'Expected s3FileKey',
  streamingRestoreFailureReason: 'Failure Reason',
  streamingRestoreReasonLabel: 'Restore Reason',
  streamingRestoreReasonPlaceholder: 'Enter a reason for this restore.',
  streamingRestoreReasonRequired: 'Please enter a restore reason.',
  streamingRestoreExecute: 'Restore',
  streamingRestoreHistoryStatus: 'Status',
  streamingRestoreHistoryStatusRestored: 'Restored',
  streamingRestoreHistoryStatusFailed: 'Failed',
  streamingRestoreInvalidBarcode: 'Only exact 11-digit numeric barcodes can be searched.',
  streamingRestoreNoSelection: 'Select at least one recording to restore.',
  streamingRestoreLoadFailed: 'Failed to load restore candidates.',
  streamingRestoreRestoreSuccess: 'Restored {{restored}} recording(s).',
  streamingRestoreRestorePartial:
    'Restored {{restored}} recording(s) and failed {{failed}} recording(s).',
  streamingRestoreRestoreFailed: 'No restorable recordings were found.',
  streamingRestoreEmpty: 'No inactive recordings were found.',
  streamingRestoreHistoryEmpty: 'No restore history was found.',
  streamingRestoreHistoryEmptyDetail: 'No detailed items were saved.',
};

export default barcodeTranslation;
